import axios from "axios";
import { urlBase } from "./config";

export const createDepartment = async (departmentData, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.post(
      `${urlBase}/boticario/departments`,
      departmentData,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating department:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const updateDepartment = async (id, departmentData, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.put(
      `${urlBase}/boticario/departments/${id}`,
      departmentData,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating department:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const deleteDepartment = async (id, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
    };

    const response = await axios.delete(
      `${urlBase}/boticario/departments/${id}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting department:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchDepartments = async (
  token,
  offset,
  limit,
  search,
  columnSearch,
  eventId
) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/departments`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          offset,
          limit,
          search,
          columnSearch,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar departamentos:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchEstoqueReports = async (token, eventId) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/stock/report`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar estoque:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchAttendeeReports = async (token, eventId) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/attendees/report`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar estoque:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchRegistersReports = async (token, eventId) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/registers/report`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar estoque:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const createCps = async (cpData, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.post(`${urlBase}/boticario/cps`, cpData, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao criar CP: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const editCp = async (cpData, bearerToken, cpId) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.put(
      `${urlBase}/boticario/cps/${cpId}`,
      cpData,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error Editing CP: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchCps = async (
  token,
  offset,
  limit,
  search,
  columnSearch,
  eventId,
  enable
) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/cps`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          offset,
          limit,
          search,
          columnSearch,
          enable,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar CPs: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchCpsReports = async (token, eventId) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/cps/report`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar CPS REPORT:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const deleteCp = async (id, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
    };

    const response = await axios.delete(`${urlBase}/boticario/cps/${id}`, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error deleting CP: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const reactiveCp = async (id, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
    };

    const response = await axios.post(
      `${urlBase}/boticario/enable/cps/${id}`,
      {},
      { headers }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error reactivating CP: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchAttendeePaid = async (token) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/attendees/paid`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar attendees:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const createPackages = async (packData, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.post(
      `${urlBase}/boticario/packages`,
      packData,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao criar o pacote: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const updatePackage = async (packId, packData, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.put(
      `${urlBase}/boticario/packages/${packId}`,
      packData,
      {
        headers,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error ao editar o pacote: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchPackages = async (
  token,
  offset,
  limit,
  search,
  columnSearch,
  eventId,
  enable
) => {
  try {
    const response = await axios.get(
      `${urlBase}/boticario/events/${eventId}/packages`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          offset,
          limit,
          search,
          columnSearch,
          enable,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar os pacotes de quarto: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchEventsXGroups = async (
  token,
  page,
  limit,
  eventId,
  groupId,
  tag
) => {
  try {
    const response = await axios.get(`${urlBase}/boticario/eventsxgroups`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        page,
        limit,
        ...(eventId && { eventId }),
        ...(groupId && { groupId }),
        ...(tag && { tag }),
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar vínculos eventos x grupos: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const createEventsXGroups = async (data, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.post(
      `${urlBase}/boticario/eventsxgroups`,
      data,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao criar vínculo evento x grupo: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const updateEventsXGroups = async (id, data, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.put(
      `${urlBase}/boticario/eventsxgroups/${id}`,
      data,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao atualizar vínculo evento x grupo: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const deleteEventsXGroups = async (id, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
    };

    const response = await axios.delete(
      `${urlBase}/boticario/eventsxgroups/${id}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao deletar vínculo evento x grupo: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const fetchEnabledEvents = async (token, page, limit) => {
  try {
    const response = await axios.get(`${urlBase}/boticario/enabled-events`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { page, limit },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Erro ao buscar eventos habilitados: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const createEnabledEvent = async (data, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    };

    const response = await axios.post(
      `${urlBase}/boticario/enabled-events`,
      data,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao habilitar evento: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const deleteEnabledEvent = async (eventId, bearerToken) => {
  try {
    const headers = {
      Authorization: `Bearer ${bearerToken}`,
    };

    const response = await axios.delete(
      `${urlBase}/boticario/enabled-events/${eventId}`,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erro ao desabilitar evento: ",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
